import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  loading: false,
  error: null,
  products: [],
  storeProduct: {},
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    loadProductsRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadProductsSuccess(state, action: any) {
      state.loading = false;
      state.error = null;

      state.products = action?.payload?.results;
      state.paginationOption = {
        page: action.payload?.page,
        pageSize: action.payload?.pageSize,
        totalItems: action.payload?.totalItems,
        numberOfPages: action.payload?.numberOfPages,
      };
    },
    loadProductsFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    loadProductRequested(state, action: PayloadAction<{}>) {
      state.productLoading = true;
      state.error = null;
    },
    loadProductSuccess(state, action: any) {
      state.productLoading = false;
      state.error = null;
      state.product = action.payload.result;
    },
    loadProductFail(state, action: PayloadAction<{}>) {
      state.productLoading = false;
      state.error = action.payload;
    },

    storeProductRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storeProductSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeProduct = action.payload;
    },
    storeProductFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    updateProductRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    updateProductSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.updateProduct = action.payload;
    },
    updateProductFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    storeProductImageRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storeProductImageSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeProductImage = action.payload;
    },
    storeProductImageFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    deleteProductRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    deleteProductSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.deleteProduct = action.payload;
    },
    deleteProductFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    loadProductsBySubCategoriesRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadProductsBySubCategoriesSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.productsBySubCategories = action?.payload?.result;
    },
    loadProductsBySubCategoriesFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    loadNonPaginatedProductRequested(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    loadNonPaginatedProductSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.nonPaginatedProduct = action?.payload?.results;
    },

    loadNonPaginatedProductFail(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },

    stockStatusChangeRequested(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    stockStatusChangeSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.stockStatusChange = action?.payload;
    },

    stockStatusChangeFail(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },
    updatePriceRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    updatePriceSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.updatePrice = action.payload;
    },
    updatePriceFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadProductsRequested,
  loadProductsSuccess,
  loadProductsFail,
  loadProductFail,
  loadProductRequested,
  loadProductSuccess,
  storeProductRequested,
  storeProductSuccess,
  storeProductFail,
  storeProductImageRequested,
  storeProductImageSuccess,
  storeProductImageFail,
  deleteProductRequested,
  deleteProductFail,
  deleteProductSuccess,
  loadProductsBySubCategoriesFail,
  loadProductsBySubCategoriesRequested,
  loadProductsBySubCategoriesSuccess,
  updateProductFail,
  updateProductRequested,
  updateProductSuccess,
  loadNonPaginatedProductFail,
  loadNonPaginatedProductRequested,
  loadNonPaginatedProductSuccess,
  stockStatusChangeFail,
  stockStatusChangeRequested,
  stockStatusChangeSuccess,
  updatePriceFail,
  updatePriceRequested,
  updatePriceSuccess,
} = productsSlice.actions;

export default productsSlice.reducer;
